import { m8API } from 'services/production/m8';
import { normalizeM8StatementDTO } from 'services/production/utils/normalizeM8StatementDTO';
import { normalizeM8UserFullInfo } from 'services/production/utils/normalizeM8UserFullInfo';
import { Org } from 'types/orgInfoTypes';
import { Person } from 'types/personTypes';
import { GetGiroPaymentManagerDataService } from 'types/services';
import { createGiroPaymentManagerData } from 'utils/giroPaymentManagerUtils';
import { createOrg } from 'utils/orgUtils';
import { createPerson } from 'utils/personUtils';

export const getGiroPaymentManagerData: GetGiroPaymentManagerDataService = async (
  paymentId
) => {
  const m8Statement = await m8API.admin.getStatementById({
    idStatement: paymentId,
  });

  const data = createGiroPaymentManagerData();

  let person: Person = createPerson();
  let org: Org = createOrg();

  if (m8Statement.idUser) {
    const [
      m8UserFullInfo,
      balance,
      m8DebitDTOs,
      m8UserLegalRequisites,
    ] = await Promise.all([
      m8API.admin.getUser(m8Statement.idUser),
      m8API.admin.getAccountBalance({
        idUser: m8Statement.idUser,
      }),
      m8API.admin.getNotPaidDebits({
        idUser: m8Statement.idUser,
      }),
      m8API.admin.getUserLegalRequisites({
        idUser: m8Statement.idUser,
      }),
    ]);

    if (m8UserLegalRequisites) {
      data.m8UserLegalRequisites = m8UserLegalRequisites;
    }

    data.balance = balance;

    data.m8DebitDTOs = m8DebitDTOs;

    person = normalizeM8UserFullInfo(m8UserFullInfo).toPerson();
    org = normalizeM8UserFullInfo(m8UserFullInfo).toOrg();
  }

  data.giroPayment = normalizeM8StatementDTO(m8Statement).toGiroPayment(
    person,
    org
  );

  return data;
};
